module.exports = __webpack_public_path__ + "static/grafika4@2x-3e053a2b3e6be0571c0b8460c07b5a96.png";